import React, { useMemo, useState } from 'react';
import { Button, Card, Input, List, Space, Typography } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { MOCK_DICTIONARY, type WordEntry } from '../data/mockDictionary';
import { useAuth } from '../auth/AuthContext';

export function DashboardHome() {
  const { user } = useAuth();
  const [query, setQuery] = useState('');

  const normalized = query.trim().toLowerCase();
  const results = useMemo(() => {
    if (!normalized) return [];
    return MOCK_DICTIONARY.filter((w) => {
      if (w.lemma.toLowerCase().includes(normalized)) return true;
      return w.definitions.some((d) => d.toLowerCase().includes(normalized));
    });
  }, [normalized]);

  return (
    <Space direction="vertical" size={16} style={{ width: '100%', maxWidth: 960 }}>
      <Card>
        <Space direction="vertical" size={6}>
          <Typography.Title level={2} style={{ margin: 0 }}>
            Welcome{user ? `, ${user.username}` : ''}.
          </Typography.Title>
          <Typography.Text type="secondary">
            Use the search below to try the dictionary UI, or open <strong>Languages</strong> in the
            sidebar to manage languages.
          </Typography.Text>
        </Space>
      </Card>

      <Card title="Dictionary search">
        <Space.Compact style={{ width: '100%' }}>
          <Input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Type a word or meaning…"
            aria-label="Dictionary search"
          />
          <Button type="primary" icon={<SearchOutlined />} disabled={!normalized}>
            Search
          </Button>
        </Space.Compact>

        <div style={{ marginTop: 16 }}>
          {normalized ? (
            results.length ? (
              <List<WordEntry>
                itemLayout="vertical"
                dataSource={results}
                renderItem={(word) => (
                  <List.Item style={{ paddingBlock: 10 }}>
                    <Typography.Text strong style={{ fontSize: 16 }}>
                      {word.lemma}
                    </Typography.Text>
                    <div style={{ marginTop: 6 }}>
                      {word.partOfSpeech ? (
                        <Typography.Text type="secondary">{word.partOfSpeech}</Typography.Text>
                      ) : null}
                    </div>
                    <Typography.Paragraph style={{ margin: '8px 0 0' }}>
                      {word.definitions[0]}
                    </Typography.Paragraph>
                  </List.Item>
                )}
              />
            ) : (
              <Typography.Text type="secondary">No matches.</Typography.Text>
            )
          ) : (
            <Typography.Text type="secondary">Start typing to see matches.</Typography.Text>
          )}
        </div>
      </Card>
    </Space>
  );
}
